import React, { useEffect, useState, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { useDispatch } from 'react-redux';

import { appStatusStatisticsData } from 'lib/api/datacenter';
import { makeHeadData } from 'lib/commonLib';
import { dayColor, getHeadObj } from 'lib/commonLib';
import { showSuccessSnackbar } from 'modules/snackbar';

import ContentsWrap from 'components/molecules/ContentsWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

import AppStatusGraph from './AppStatusGraph';

const AppStatusStatistics = () => {
  const dispatch = useDispatch();
  const initParams = {
    sDate: moment().add(-1, 'week').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
  };
  const [params, setParams] = useState(initParams);
  const [tableData, setTableInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [initialization, setInitialization] = useState(false);

  const tableInfoJson = {
    DAILY_NEW_ADID: {
      headList: [
        {
          id: 'STATS_DTTM',
          label: '날짜',
          orderFlag: false,
          displayFlag: true,
          type: 'string',
          format: '@',
        },
        {
          id: 'NEW_ADID',
          label: '신규 ADID',
          orderFlag: false,
          displayFlag: true,
          type: 'number',
          format: '#,##0',
        },
      ],
      sort: 'desc',
      order: 'STATS_DTTM',
    },
    GG_CATEGORY: {
      headList: [
        {
          id: 'CATEGORY',
          label: '카테고리',
          orderFlag: false,
          displayFlag: true,
          type: 'string',
          format: '@',
        },
        {
          id: 'APP_CNT',
          label: 'APP 수',
          orderFlag: false,
          displayFlag: true,
          type: 'number',
          format: '#,##0',
        },
      ],
      sort: 'desc',
      order: 'APP_CNT',
    },
    GG_GAME_CATEGORY: {
      headList: [
        {
          id: 'CATEGORY',
          label: '카테고리',
          orderFlag: false,
          displayFlag: true,
          type: 'string',
          format: '@',
        },
        {
          id: 'APP_CNT',
          label: 'APP 수',
          orderFlag: false,
          displayFlag: true,
          type: 'number',
          format: '#,##0',
        },
      ],
      sort: 'desc',
      order: 'APP_CNT',
    },
  };

  /**
   * 테이블 나오는 순서
   */
  const tableOrder = [
    { key: 'DAILY_NEW_ADID', label: '일자별 패키지전송 신규ADID' },
    { key: 'GG_CATEGORY', label: '구글 카테고리 전체현황' },
    { key: 'GG_GAME_CATEGORY', label: '구글게임 카테고리 전체현황' },
  ];

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  useEffect(() => {
    setInitialization(false);
    getData(); // eslint-disable-next-line
  }, [params]);

  const getData = () => {
    let newTableInfo = {};
    setLoading(true);
    appStatusStatisticsData({
      params,
    })
      .then((response) => {
        const { data } = response.data;
        newTableInfo = {
          DAILY_NEW_ADID: data.DAILY_NEW_ADID,
          GG_CATEGORY: data.GG_CATEGORY,
          GG_GAME_CATEGORY: data.GG_GAME_CATEGORY,
        };
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      })
      .finally(() => {
        setLoading(false);
        setTableInfo(newTableInfo);
      });
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setParams(initParams);
      setInitialization(true);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const customized = {
    STATS_DTTM: {
      makeBody: (rowObj, headsMap) => {
        const statsDttm = getHeadObj(headsMap, 'STATS_DTTM');
        return rowObj['STATS_DTTM'] !== 'total'
          ? dayColor(rowObj['STATS_DTTM'], statsDttm.type, statsDttm.format)
          : rowObj['STATS_DTTM'];
      },
    },
  };

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
        />
      </NewFilterWrap>
      <AppStatusGraph params={params} />
      <ContentsWrap contentsCount={3}>
        {(() => {
          const result = [];
          for (let i = 0; i < tableOrder.length; i++) {
            const { key, label } = tableOrder[i];
            const tableIf = tableInfoJson[key];
            result.push(
              <NewTableContainer
                key={key}
                params={{
                  ...params,
                  sort: tableInfoJson[key].sort,
                  order: tableInfoJson[key].order,
                }}
                getParam={getParam}
                customized={customized}
                useSearch={false}
                useExcel={false}
                useTotal={false}
                useFetch={false}
                propsList={tableData[key]}
                propsHeadCells={makeHeadData(tableIf.headList)}
                useCustomTable
                title={label}
                rowsPerPage={5}
                loading={loading}
                useFullScreen={false}
              />
            );
          }
          return result;
        })()}
      </ContentsWrap>
    </>
  );
};

export default withRouter(AppStatusStatistics);
